import React from 'react'
import { Form } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { loadAllCompanies } from '../../../common/companies/actions'

class CompanyFilter extends React.Component {
  componentWillMount() {
    const { loadAllCompanies, companies } = this.props
    if (!companies.size) loadAllCompanies({ sort: 'nameSort' })
  }
  render() {
    // eslint-disable-next-line no-unused-vars
    const { companies, loadAllCompanies, value, onChange, ...remainingProps } = this.props
    const companyOptions = companies.reduce((options, company) => {
      options.push({ value: company._id, text: company.name })
      return options
    }, [])
    if (!remainingProps.multiple) companyOptions.unshift({ value: '', text: 'Vše' })

    let realValue = value
    if (!realValue && remainingProps.multiple) realValue = []
    return (
      <Form.Select
        options={companyOptions}
        value={realValue}
        onChange={(e, value) => onChange(value)}
        {...remainingProps}
      />
    )
  }
}

CompanyFilter.defaultProps = {
  multiple: false,
  value: '',
}

CompanyFilter.propTypes = {
  loadAllCompanies: React.PropTypes.func.isRequired,
  companies: React.PropTypes.object.isRequired,
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default connect(state => ({
  companies: state.companies.all,
}), { loadAllCompanies })(CompanyFilter)



// WEBPACK FOOTER //
// ./src/browser/components/filters/CompanyAllFilter.js